import { twMerge } from "@/utils/twMerge";

import { extractNumericData, extractNumericData2DFromTiptap } from "./dataAnalysisUtils";

import type { DataSource } from "./dataAnalysisUtils";
import type { DocumentModel } from "@/models/DocumentModel";

export const TableDataPreview = ({ source, doc }: { source: DataSource; doc: DocumentModel }) => {
  if (source.kind !== "tiptap-table") return null;

  const data2d = extractNumericData2DFromTiptap(source.node, doc);
  if (data2d) {
    return (
      <div className="pointer-events-none font-mono text-base opacity-60">
        <div className="relative z-10 table border-collapse">
          {data2d.map((row, i) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              className="table-row relative"
            >
              {row.map((cell, j) => (
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={j}
                  className={twMerge(
                    "table-cell px-2 py-1 [&:not(:last-child)]:border-r border-b border-dashed border-gray-400 dark:border-gray-500",
                    i === data2d.length - 1 && "border-b-0",
                  )}
                >
                  <div className="flex justify-center min-w-[2ch]">{cell}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }

  const data1d = extractNumericData(source);
  return (
    <div className="pointer-events-none font-mono text-base opacity-60">
      <div className="flex flex-wrap gap-x-4 gap-y-2 mx-1 my-0.5 items-center">
        {data1d.map((cell, j) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={j}
            className="text-center min-w-[1ch]"
          >
            {cell}
          </div>
        ))}
      </div>
    </div>
  );
};
